import { useEffect } from "react";
import L from "leaflet";
import { useMap } from "react-leaflet";

export type FocusPoint = {
  lat: number;
  lon: number;
  /** Changes on every request, so asking for the same point again flies back to it. */
  key: string;
};

/** Close enough that a site's geofence and its numbered step pins both show. */
const FOCUS_ZOOM = 17;
const FLY_SECONDS = 1.2;

export const FlyToPoint = ({ point }: { point?: FocusPoint | null }) => {
  const map = useMap();
  useEffect(() => {
    if (!point) return;
    const target = L.latLng(point.lat, point.lon);
    const zoom = Math.max(map.getZoom(), FOCUS_ZOOM);
    // flyTo animates its zoom arc even when it has nowhere to go, which made
    // stepping between two jobs at one site shake the map.
    const offCentre = map.latLngToContainerPoint(target).distanceTo(map.getSize().divideBy(2));
    if (zoom === map.getZoom() && offCentre <= 2) return;
    // flyTo, not panTo: at this zoom a straight pan streaks the map past; the
    // zoom-out arc keeps where you left and where you land both in view.
    map.flyTo(target, zoom, { duration: FLY_SECONDS });
    // Keyed on `key` alone: the point is rebuilt whenever the route data refreshes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [point?.key, map]);
  return null;
};
